export class UpdatePolicyRequest {
  full_contract_number: string;
  customer_id?: string;

  update_pet_info: {
    old_value: PetInfo;
    new_value: PetInfo;
  };

  update_insurance_info: {
    old_value: InsuranceInfo;
    new_value: InsuranceInfo;
  };


  constructor(fullContractNumber: string, updatePetInfo: {
    old_value: PetInfo;
    new_value: PetInfo
  }, updateInsuranceInfo: { old_value: InsuranceInfo; new_value: InsuranceInfo }) {
    this.full_contract_number = fullContractNumber;
    this.update_pet_info = updatePetInfo;
    this.update_insurance_info = updateInsuranceInfo;
  }
}

export interface InsuranceInfo {
  product_bundle: string; // S/M/L
  preexisting_conditions_coverage: boolean;
  medical_food_coverage: boolean;
  preventive_care_coverage: boolean;
  annual_franchise: number;
  deductible_percentage_until_9_years: number;
  payment_interval: string
}

export interface PetInfo {
  pet_name: string;
  pet_species: string;
  pet_gender: string;
  breed_type: boolean; // Assuming "mischrasse_haustier" is a boolean
  breed: string;
  birthdate: string;
  neutered: boolean;
  housecat?: boolean;
}
